import { useCallback } from 'react';

let controller;

const useAbortController = () => {
  if (!controller) {
    controller = new AbortController();
  }

  const getController = () => controller;

  const resetController = useCallback(() => {
    controller.abort(); // Abort any ongoing requests
    controller = new AbortController(); // Create a new controller
  }, []);

  return { getController, resetController };
};

export default useAbortController;
